import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";

export type AnnouncementPageHeaderProps = {
  backTo: string;
  title: string;
  subtitle?: string;
};

export function AnnouncementPageHeader({
  backTo,
  title,
  subtitle,
}: AnnouncementPageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
      <Link
        to={backTo}
        className="p-2 -ml-2 text-slate-400 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-200 rounded-full hover:bg-slate-100 dark:hover:bg-[#141517] transition-colors w-fit"
      >
        <ArrowLeft className="w-5 h-5" />
      </Link>
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">{title}</h1>
        {subtitle ? (
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">{subtitle}</p>
        ) : null}
      </div>
    </div>
  );
}
